import React, {Component} from 'react';

import {Loading} from "../Loading";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {ColumnHeader} from "./column_header/ColumnHeader";
import {DashboardItemsOrdering} from "./DashboardItemsOrdering";
import {SORT_DOWN, SORT_UP} from "../../utils/Array.extensions";
import {
    BUSINESS_UNIT_COLUMN,
    COLUMN_HEADER_INFORMATION, DEFAULT_COLUMN_SET,
    GET_COLUMN_DATA,
    INDICATORS_COLUMNS,
    LABELS_COLUMN,
    getColumnHeaderInformation,
    getDefaultColumnSet,
    getColumnData
} from "./columns";
import {DashboardHeader} from "./DashboardHeader";
import {DashboardConfig} from "../../utils/DashboardConfig";
import {clearColumnsUrlParam} from "../../utils/DashboardColumnsUrlParams";
import {RowWithErrorHandler} from "./rows/RowWithErrorHandler";
import DashboardRow from "./rows/DashboardRow";
import {Alert} from "reactstrap";
import {ColumnWithOrdering} from "./ColumnWithOrdering";
import {LocalStorage} from "../../utils/LocalStorage";
import {PrimaryButton} from "../buttons/PrimaryButton";
import {DashboardSetupOnboarding} from "./DashboardSetupOnboarding";
import { withTranslation } from 'react-i18next';

export class DashboardClass extends Component {
    constructor(props) {
        super(props);
        this._dashboardConfig = new DashboardConfig();
        this.state = {
            loaded: false,
            businessUnits: [],
            businessUnitRowsData: {},
            columnOrdering: this.getInitialOrdering(),
            activeColumns: [],
            activeColumnsSetId: null, // ID del set de columnas activo
            columnsSets: [],
            filters: {
                textFilter: this._dashboardConfig.getTextFilter(),
                issuesOnly: this._dashboardConfig.getIssuesOnlyFilter(),
                labelsFilter: this._dashboardConfig.getLabelsFilter(),
                platformFilter: this._dashboardConfig.getPlatformFilter(),
            },
            hiddenColumns: this._dashboardConfig.getHiddenColumns(),
            isDownloading: false,
            flexIndicators: null,
            ga4Indicators: null,
            ecommerceIndicators: null,
            paidMediaIndicators: null,
            metaIndicators: null,
            canEditFlexIndicators: false,
            moduleInsightsEnabled: false,
            bulkUserBusinessUnitsSyncEnabled: false,
            refreshKey: 0, // Key para forzar re-render de las filas

            // Resizing States
            isResizing: false,
            resizingStartX: 0,
            resizingStartWidth: 0,
            resizingCurrentTh: null,
            resizingTableWidth: window.innerWidth-72, // Track table width here

            showingEventualOutOfPeriodBusinessUnits: false
        };


        this._dashboardItems = new DashboardItemsOrdering();
        this.thRefs = {}; // Using an object to store refs for each column by `columnId`
        this.tableRef = React.createRef(); // Add ref for the table element
        //FEDE: Lo comento porque no lo hice funcionar
        //this.customWidthByColumnId = this.customWidthByColumnIdFromLocalStorage();

        this.handleTextFilterChange = this.handleTextFilterChange.bind(this);
        this.handleToggleIssuesOnly = this.handleToggleIssuesOnly.bind(this);
        this.handleLabelsFilterChange = this.handleLabelsFilterChange.bind(this);
        this.handleOrderingChange = this.handleOrderingChange.bind(this);
        this.handleBusinessUnitDataFetched = this.handleBusinessUnitDataFetched.bind(this);
        this.handleColumnStateChange = this.handleColumnStateChange.bind(this);
        this.handleColumnsPositionChange = this.handleColumnsPositionChange.bind(this);
        this.handleSaveColumnSet = this.handleSaveColumnSet.bind(this);
        this.handleApplyColumnSet = this.handleApplyColumnSet.bind(this);
        this.handleDeleteColumnSet = this.handleDeleteColumnSet.bind(this);
        this.handleLabelsChange = this.handleLabelsChange.bind(this);
        this.handleSnoozeAllAlerts = this.handleSnoozeAllAlerts.bind(this);
        this.handleStopSnoozeForAllAlerts = this.handleStopSnoozeForAllAlerts.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.handlePlatformFilterChange = this.handlePlatformFilterChange.bind(this);
        this.setColumnsSets = this.setColumnsSets.bind(this);
        this.setActiveColumns = this.setActiveColumns.bind(this);
        this.handleAfterSuccessfulBusinessUnitSubmit = this.handleAfterSuccessfulBusinessUnitSubmit.bind(this);
        this.handleDownloadPromise = this.handleDownloadPromise.bind(this);
        this.handleSyncAllBusinessUnits = this.handleSyncAllBusinessUnits.bind(this);

    }

    // customWidthByColumnIdFromLocalStorage() {
    //     const columnWidths = JSON.parse(localStorage.getItem('columnWidths'));
    //     return (columnWidths) ? columnWidths : {};
    // }
    //
    // restoreColumnWidths() {
    //     // Obtén los anchos guardados de localStorage
    //     const columnWidths = JSON.parse(localStorage.getItem('columnWidths'));
    //     if (columnWidths) {
    //         // Itera sobre cada columna y aplica el ancho guardado
    //         Object.keys(columnWidths).forEach(columnId => {
    //             const th = this.thRefs[columnId];
    //             if (th) {
    //                 th.style.width = `${columnWidths[columnId]}px`;
    //             }
    //         });
    //     }
    // }

    getInitialOrdering() {
        const columnOrderingSaved = this.getSavedColumnOrdering();
        if(columnOrderingSaved !== null)
            return columnOrderingSaved;

        return DashboardItemsOrdering.defaultOrdering();
    }

    getSavedColumnOrdering() {
        const columnOrderingSaved = this._dashboardConfig.getColumnOrdering();

        if (columnOrderingSaved !== null) {
            const columnOrdering = JSON.parse(columnOrderingSaved)
            return new ColumnWithOrdering(columnOrdering['columnId'], columnOrdering['orderingDirection'])
        }

        return null;
    }

    componentDidMount() {
        this.getBasicDataAndConfigurateColumns();

        // Add mousemove and mouseup listeners
        document.addEventListener('mousemove', this.resizeColumn);
        document.addEventListener('mouseup', this.stopResize);

        // Set the initial table width
        if (this.tableRef.current) {
            const initialTableWidth = Math.max(this.tableRef.current.offsetWidth, window.innerWidth);
            this.setState({resizingTableWidth: initialTableWidth});
        }

        // FEDE: Lo comento porque no lo hice funcionar
        //this.restoreColumnWidths();
    }

    componentWillUnmount() {
        // Cleanup event listeners when component is unmounted
        document.removeEventListener('mousemove', this.resizeColumn);
        document.removeEventListener('mouseup', this.stopResize);
    }

    initResize = (e, columnId) => {
        const th = this.thRefs[columnId];
        if (!th) return;

        // Guardo el tamaño inicial de la tabla aquí
        const initialTableWidth = this.tableRef.current ? this.tableRef.current.offsetWidth : window.innerWidth;


        this.setState({
            isResizing: true,
            resizingStartX: e.pageX,
            resizingStartWidth: th.offsetWidth,
            resizingCurrentTh: th,
            resizingInitialTableWidth: initialTableWidth, // Almacena el ancho inicial de la tabla
        });
    };

    resizeColumn = (e) => {
        const { isResizing, resizingStartX, resizingStartWidth, resizingCurrentTh } = this.state;
        if (!isResizing || !resizingCurrentTh) return;

        const diffX = e.pageX - resizingStartX;
        const newThWidth = resizingStartWidth + diffX;

        // Update the width of the column being resized
        resizingCurrentTh.style.width = `${newThWidth}px`;

        // El nuevo ancho de la tabla se calcula sumando diffX al ancho inicial de la tabla
        const newTableWidth = Math.max(this.state.resizingInitialTableWidth + diffX, window.innerWidth); // Asegúrate de que no sea más pequeño que el ancho de la ventana

        this.tableRef.current.style.width = `${newTableWidth}px`;

        // Guarda el nuevo ancho de la columna en localStorage
        // FEDE: Lo comento porque no lo hice funcionar
        //this.saveColumnWidth(resizingCurrentTh.dataset.columnId, newThWidth);

        // Update state with the new table width
        this.setState({ resizingTableWidth: newTableWidth });
    };

    saveColumnWidth = (columnId, width) => {
        console.log(`Se guarda la columna ${columnId} con width ${width}`);
        LocalStorage.saveColumnWidth(columnId, width);
    };

    stopResize = () => {
        this.setState({
            isResizing: false,
            currentTh: null,
        });
    };

    setActiveColumns(columnsSetData) {
        // Nos quedamos con las que son validas
        const activeColumns = columnsSetData.columns.filter((columnId) => { return this.isValidColumnId(columnId); });

        this.setState({
            activeColumns: activeColumns,
            activeColumnsSetId: columnsSetData.id
        });
        this.setState((prevState) => {
            return {columnsSets: {...prevState.columnsSets, [columnsSetData.id]: columnsSetData}}
        });

        // Si hay columnas compartidas via URL, aplicarlas después de la configuración default
        this._applySharedColumnsIfPresent();
    }

    _applySharedColumnsIfPresent() {
        const sharedColumns = this.props.sharedColumns;
        if (!sharedColumns || sharedColumns.length === 0) return;

        const validColumns = sharedColumns.filter((columnId) => this.isValidColumnId(columnId));
        if (validColumns.length === 0) return;

        this.setState({
            activeColumns: validColumns,
            activeColumnsSetId: null
        });
        this._dashboardConfig.saveActiveColumns(validColumns);
        clearColumnsUrlParam();
    }

    setColumnsSets(columnsSets) {
        this.setState({columnsSets: columnsSets});
    }

    // api

    getBasicDataAndConfigurateColumns() {
        new APIClient(API_URL + 'dashboard/basic-data').call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this._addOrderingValuesForFirstColumn(response.data.business_units);
                    this._setBusinessUnitsAndIndicatorsAndSetLoadedAndConfigureColumns(response.data.business_units, response.data.flex_indicators_indicators, response.data.ga4_indicators, response.data.ecommerce_indicators, response.data.paid_media_indicators, response.data.meta_indicators, response.data.can_edit_flex_indicators, response.data.module_insights_enabled, response.data.bulk_user_business_units_sync_enabled);

                } else {
                    this.setState({loaded: true});
                    alert(response.error_message);
                }
            });
    }

    // event handlers

    handleAfterSuccessfulBusinessUnitSubmit(businessUnitId) {
        this.props.history.push(`/business-unit/${businessUnitId}/accounts?showAddAccountModal=true`);
    }

    handleLabelsChange(businessUnitId, labels) {
        const businessUnits = this.state.businessUnits.map(businessUnitData => {
            if (businessUnitData.id === businessUnitId) {
                return {
                    ...businessUnitData,
                    labels: labels
                }
            } else {
                return businessUnitData
            }
        });
        this._setBusinessUnits(businessUnits);
    }

    // event handlers - filters and ordering

    handlePlatformFilterChange(platformValue) {
        this.setState((prevState) => {
            return {filters: {...prevState.filters, platformFilter: platformValue}}
        });
        this._dashboardConfig.savePlatformFilter(platformValue);

    }

    handleTextFilterChange(textInput) {
        this.setState((prevState) => {
            return {filters: {...prevState.filters, textFilter: textInput}}
        });
        this._dashboardConfig.saveTextFilter(textInput)
    }

    handleToggleIssuesOnly(isOn) {
        this.setState((prevState) => {
            return {filters: {...prevState.filters, issuesOnly: isOn}}
        });
        this._dashboardConfig.saveIssuesOnlyFilter(isOn)
    }

    handleLabelsFilterChange(selectedLabels) {
        this.setState((prevState) => {
            return {filters: {...prevState.filters, labelsFilter: selectedLabels}}
        });
        this._dashboardConfig.saveLabelsFilter(selectedLabels)
    }

    handleHiddenColumnsChange = (hiddenColumns) => {
        const normalized = Array.isArray(hiddenColumns) ? hiddenColumns : [];
        this.setState({hiddenColumns: normalized});
        this._dashboardConfig.saveHiddenColumns(normalized);
    }

    handleOrderingChange(columnOrdering) {
        this.setState({columnOrdering: columnOrdering});
        this._setBusinessUnits(this.state.businessUnits, columnOrdering);
        this._dashboardConfig.saveColumnOrdering(columnOrdering);
    }

    // event handlers - business unit rows data fetched

    handleBusinessUnitDataFetched(businessUnitId, businessUnitData) {
        if (!businessUnitData) {
            return;
        }
        const columns = Object.keys(businessUnitData);
        columns.forEach((column) => {
            const columnData = businessUnitData[column];
            const orderingValues = (columnData != null && typeof columnData === 'object') ? columnData.ordering_values : null;
            this._dashboardItems.addOrderingValues(businessUnitId, column,
                (orderingValues != null && Array.isArray(orderingValues)) ? orderingValues : [Number.MIN_SAFE_INTEGER]);
        });

        // Si tengo un orden guardado, aca lo implemento.
        // Se podria verificar de no cambiar nada si es el mismo orden que ya esta
        const columnOrderingSaved = this.getSavedColumnOrdering();

        if(columnOrderingSaved !== null) {
            const sortedBusinessUnits = this._getSortedBusinessUnit(columnOrderingSaved, this.state.businessUnits);
            this._setBusinessUnitRowsDataForAndBusinessUnits(businessUnitId, businessUnitData, sortedBusinessUnits)
        }
        else
            this._setBusinessUnitRowsDataFor(businessUnitId, businessUnitData);
    }

    // event handlers - download dashboard data

    handleDownload() {
        this.setIsDownloadingState(true);
        this.downloadDashboardData();
    }

    handleDownloadPromise(response) {
        if(response.status !== 'OK') {
            alert(response.error_message);
        }
        this.setIsDownloadingState(false)
    }

    downloadDashboardData() {
        let downloadUrl = this.urlForDownload();

        return new APIClient(downloadUrl).download('GET', this.defaultDashboardFilename(), this.handleDownloadPromise);
    }

    urlForDownload() {
        let columns = JSON.stringify(this.state.activeColumns);
        let filters = JSON.stringify(this.state.filters);

        return `${API_URL}dashboard/export-columns-data?columns=${columns}&filters=${filters}`
    }

    defaultDashboardFilename() {
        return `Dashboard-Data.csv`;
    }

    setIsDownloadingState(isDownloading) {
        this.setState({isDownloading: isDownloading});
    }

    handleSyncAllBusinessUnits(event) {
        if (event) {
            event.preventDefault();
        }
        const { t } = this.props;
        new APIClient(API_URL + 'user/sync-all-business-units').call('POST')
            .then((response) => {
                if (response.status === 'OK') {
                    // Esperar 3 segundos antes de refrescar las líneas de control
                    // para dar tiempo al servidor de actualizar el estado a "actualizando"
                    setTimeout(() => {
                        this.getBasicDataAndConfigurateColumns();
                    }, 3000);
                } else {
                    alert(response.error_message);
                }
            });
            // .catch((error) => {
            //     alert(t('dashboard.sync_all_error'));
            // });
    }

    // helpers

    _setBusinessUnits(businessUnits, columnOrdering = null) {
        const sortedBusinessUnits = this._getSortedBusinessUnit(columnOrdering, businessUnits);
        this.setState({businessUnits: sortedBusinessUnits});
    }

    _getSortedBusinessUnit(columnOrdering, businessUnits) {
        if (columnOrdering === null) {
            columnOrdering = this.state.columnOrdering;
        }
        const sortedBusinessUnits = this._dashboardItems.sortByColumn(businessUnits, columnOrdering);
        return sortedBusinessUnits;
    }

    _setBusinessUnitsAndIndicatorsAndSetLoadedAndConfigureColumns(businessUnits, flexIndicators, ga4Indicators, ecommerceIndicators, paidMediaIndicators, metaIndicators, canEditFlexIndicators, moduleInsightsEnabled, bulkUserBusinessUnitsSyncEnabled) {
        const sortedBusinessUnits = this._dashboardItems.sortByColumn(businessUnits, this.state.columnOrdering);
        this.setState({
            businessUnits: sortedBusinessUnits,
            businessUnitRowsData: {}, // Limpiar los datos de las filas para forzar recarga
            flexIndicators: flexIndicators,
            ga4Indicators: ga4Indicators,
            ecommerceIndicators: ecommerceIndicators,
            paidMediaIndicators: paidMediaIndicators,
            metaIndicators: metaIndicators,
            loaded:true,
            canEditFlexIndicators: canEditFlexIndicators,
            moduleInsightsEnabled: moduleInsightsEnabled,
            bulkUserBusinessUnitsSyncEnabled: bulkUserBusinessUnitsSyncEnabled || false,
            refreshKey: this.state.refreshKey + 1 // Incrementar la key para forzar re-render
        });

        this._dashboardConfig.retrieveDefaultConfiguration(this.setActiveColumns);
        this._dashboardConfig.retrieveColumnsSets(this.setColumnsSets);
    }

    _addOrderingValuesForFirstColumn(businessUnits) {
        function fullNameOfBu(businessUnitData) {
            return `${businessUnitData.client_name} | ${businessUnitData.name}`;
        }

        businessUnits.forEach((businessUnit) => {
            this._dashboardItems.addOrderingValues(businessUnit.id,
                BUSINESS_UNIT_COLUMN,
                [fullNameOfBu(businessUnit)]);
        });
    }

    // event handlers - columns position and state change

    handleColumnStateChange(changedColumnId, isVisible) {
        let activeColumns;
        if (isVisible) {
            activeColumns = this.state.activeColumns.concat(changedColumnId);
        } else {
            activeColumns = this.state.activeColumns.filter((columnId) =>
                columnId !== changedColumnId
            );
        }
        // Limpiar el ID del set activo cuando se cambian las columnas manualmente
        this.setState({activeColumns: activeColumns, activeColumnsSetId: null});
        this._dashboardConfig.saveActiveColumns(activeColumns);
    }

    handleColumnsPositionChange(activeColumnsInOrder) {
        // Limpiar el ID del set activo cuando se cambian las columnas manualmente
        this.setState({activeColumns: activeColumnsInOrder, activeColumnsSetId: null});
        this._dashboardConfig.saveActiveColumns(activeColumnsInOrder);
    }

    // event handlers - column sets

    handleSaveColumnSet(setId, setName, columns) {
        const columnsToSave = columns || this.state.activeColumns;
        return this._dashboardConfig.saveColumnSet(setId, setName, columnsToSave)
            .then((savedSet) => {
                // El backend devuelve el set guardado con su ID (puede ser nuevo o actualizado)
                const savedSetId = savedSet.id || setId;
                const savedSetName = savedSet.name || setName;
                const savedSetColumns = savedSet.columns || columnsToSave;

                this.setState((prevState) => {
                    const newColumnsSets = {...prevState.columnsSets};
                    newColumnsSets[savedSetId] = {
                        id: savedSetId,
                        name: savedSetName,
                        columns: savedSetColumns
                    };
                    return {
                        columnsSets: newColumnsSets,
                        activeColumns: savedSetColumns,
                        activeColumnsSetId: savedSetId // Marcar el set guardado como activo
                    };
                });

                // Aplicar el set guardado como activo en el backend
                this._dashboardConfig.applyColumnSet(savedSetId);
                
                // Devolver el set guardado para que el modal pueda usar el ID
                return savedSet;
            })
            .catch((error) => {
                const errorMessage = error.errors && error.errors.length > 0 
                    ? error.errors[0].message 
                    : 'Error al guardar el set de columnas';
                alert(errorMessage);
                throw error; // Re-lanzar el error para que el modal pueda manejarlo
            });
    }

    handleApplyColumnSet(selectedSetId) {
        const set = this.state.columnsSets[selectedSetId];
        if (set && set.columns) {
            const validColumns = set.columns.filter((columnId) => this.isValidColumnId(columnId));
            this.setState({
                activeColumns: validColumns,
                activeColumnsSetId: selectedSetId // Actualizar el ID del set activo
            });
            // Usar set.id en lugar de selectedSetId para asegurar que se envíe el ID numérico
            const setId = set.id || selectedSetId;
            this._dashboardConfig.applyColumnSet(setId);
        }
    }

    handleDeleteColumnSet(setId) {
        const { t } = this.props;
        
        if (window.confirm(t('columns_sets_list.confirm_delete_column_set', '¿Está seguro de que desea borrar este set de columnas?'))) {
            this._dashboardConfig.deleteColumnSet(setId)
                .then(() => {
                    // Remover el set del estado
                    this.setState((prevState) => {
                        const newColumnsSets = {...prevState.columnsSets};
                        delete newColumnsSets[setId];
                        // Si se eliminó el set activo, limpiar el activeColumnsSetId
                        const newActiveColumnsSetId = String(prevState.activeColumnsSetId) === String(setId) 
                            ? null 
                            : prevState.activeColumnsSetId;
                        return {
                            columnsSets: newColumnsSets,
                            activeColumnsSetId: newActiveColumnsSetId
                        };
                    });
                    alert(t('columns_sets_list.column_set_deleted_successfully', 'Set de columnas borrado exitosamente'));
                })
                .catch((error) => {
                    const errorMessage = error.errors && error.errors.length > 0 
                        ? error.errors[0].message 
                        : t('columns_sets_list.error_deleting_column_set', 'Error al borrar el set de columnas');
                    alert(errorMessage);
                });
        }
    }

    // event handlers - snoozed alerts

    handleSnoozeAllAlerts(businessUnitId) {
        this._setSnoozedStateForAllColumns(businessUnitId, true);
    }

    handleStopSnoozeForAllAlerts(businessUnitId) {
        this._setSnoozedStateForAllColumns(businessUnitId, false);
    }

    _setSnoozedStateForAllColumns(businessUnitId, newState) {
        Object.keys(this.state.businessUnitRowsData).map((buId) => {
            if (this.state.businessUnitRowsData[buId].business_unit_id === businessUnitId) {
                let newBusinessUnit = this.state.businessUnitRowsData[buId];
                this.getIndicatorsColumns().forEach((column) => {
                    newBusinessUnit[column] = {
                        ...this.state.businessUnitRowsData[buId][column],
                        alert_snoozed: newState
                    };
                });
                this._setBusinessUnitRowsDataFor(buId, newBusinessUnit);
            }
        });
    }

    // helper methods

    _setBusinessUnitRowsDataFor(businessUnitId, businessUnitData) {
        this.setState((prevState) => {
            return {
                businessUnitRowsData: {
                    ...prevState.businessUnitRowsData,
                    [businessUnitId]: businessUnitData
                }
            }
        });
    }

    _setBusinessUnitRowsDataForAndBusinessUnits(businessUnitId, businessUnitData, businessUnits) {
        this.setState((prevState) => {
            return {
                businessUnitRowsData: {
                    ...prevState.businessUnitRowsData,
                    [businessUnitId]: businessUnitData
                },
                businessUnits: businessUnits
            }
        });
    }

    _rowDataFor(businessUnitId) {
        if (businessUnitId in this.state.businessUnitRowsData) {
            // console.log("Se supone que aca deberia tener los valores para las columnas y tengo");
            // console.log(this.state.businessUnitRowsData[businessUnitId]["FULL_PERIOD_ODS_COLUMN"]);
            return this.state.businessUnitRowsData[businessUnitId];
        } else
            return null;
    }


    // getColumnDefaultWidth(columnId) {
    //     if(this.customWidthByColumnId[columnId] !== undefined)
    //         return this.customWidthByColumnId[columnId];
    //
    //     return null;
    // }

    // rendering

    renderAddBusinessUnitButton(showText) {
        const { t } = this.props;
        return <PrimaryButton
            onClick={() => {this.props.history.push('/agency/clients/new/onboarding?source=marketing')}}
            icon="plus"
            text={t('dashboard.create_control_line')}
            showText={showText}
        />;
    }

    render() {
        if (!this.state.loaded) {
            const { t } = this.props;
            return (
                <section className="section-content">
                    <Loading message={t('common.loading')}/>
                </section>
            );
        }

        return (
            <section className="section-content dashboard">
                    <DashboardHeader
                        filters={this.state.filters}
                        availablePlatforms={this._computeAvailablePlatforms()}
                        hiddenColumns={this.state.hiddenColumns}
                        onHiddenColumnsChange={this.handleHiddenColumnsChange}
                        onTextFilterChange={this.handleTextFilterChange}
                        onToggleIssuesOnly={this.handleToggleIssuesOnly}
                        onLabelsFilterChange={this.handleLabelsFilterChange}
                        activeColumns={this.state.activeColumns}
                        activeColumnsSetId={this.state.activeColumnsSetId}
                        handleColumnStateChange={this.handleColumnStateChange}
                        onColumnsPositionChange={this.handleColumnsPositionChange}
                        columnsSets={this.state.columnsSets}
                        onSelectColumnSet={this.handleApplyColumnSet}
                        onSaveColumnSet={this.handleSaveColumnSet}
                        onDeleteColumnSet={this.handleDeleteColumnSet}
                        onDownloadDashboardData={this.handleDownload}
                        isDownloading={this.state.isDownloading}
                        onPlatformFilterChange={this.handlePlatformFilterChange}
                        flexIndicators={this.state.flexIndicators}
                        ga4Indicators={this.state.ga4Indicators}
                        ecommerceIndicators={this.state.ecommerceIndicators}
                        paidMediaIndicators={this.state.paidMediaIndicators}
                        metaIndicators={this.state.metaIndicators}
                        canEditFlexIndicators={this.state.canEditFlexIndicators}
                        moduleInsightsEnabled={this.state.moduleInsightsEnabled}
                        bulkUserBusinessUnitsSyncEnabled={this.state.bulkUserBusinessUnitsSyncEnabled}
                        onSyncAllBusinessUnits={this.handleSyncAllBusinessUnits}
                    />
                    {this._renderHiddenColumnsStyle()}
                    <div className="section-body table-box -dashboard">
                        <table id="resizableTable"
                               className="table table-striped-manually"
                               ref={this.tableRef}  // Attach table ref here
                               style={{
                                   width: `${this.state.resizingTableWidth}px`,
                                   tableLayout: 'auto',
                                   minWidth: '100%'
                               }} // Fixed layout and min width 100%
                        >
                            <thead>
                            <tr>
                                {this._renderHeader()}
                            </tr>
                            </thead>
                            <tbody>
                            {this._renderDashboardRows()}
                            </tbody>
                        </table>
                    </div>
                </section>
        )
    }

    _renderHiddenColumnsStyle() {
        const hidden = this.state.hiddenColumns || [];
        if (hidden.length === 0) return null;
        const activeColumns = this.state.activeColumns || [];
        const indices = hidden
            .map((columnId) => activeColumns.indexOf(columnId))
            .filter((index) => index >= 0)
            // DOM position is 1-based; column 1 is Business Unit, so active columns start at 2.
            .map((index) => index + 2);
        if (indices.length === 0) return null;
        const selectors = indices
            .map((n) => `#resizableTable > thead > tr > th:nth-child(${n}), #resizableTable > tbody > tr > td:nth-child(${n})`)
            .join(',\n');
        const css = `${selectors} { display: none !important; }`;
        return <style>{css}</style>;
    }

    _renderHeader() {
        if(!this._hasBusinessUnitsToShow())
            return null;

        const { t } = this.props;
        const columnHeaderInfo = getColumnHeaderInformation(t);

        return (
            <React.Fragment>
                <ColumnHeader
                    key={BUSINESS_UNIT_COLUMN}
                    title={columnHeaderInfo[BUSINESS_UNIT_COLUMN]['title']}
                    columnId={BUSINESS_UNIT_COLUMN}
                    //FEDE: Lo comento porque no lo hice funcionar
                    //defaultWidth={this.getColumnDefaultWidth(BUSINESS_UNIT_COLUMN)}
                    isActive={this.state.columnOrdering.columnId() === BUSINESS_UNIT_COLUMN}
                    canBeSorted={true}
                    hasHelper={false}
                    defaultOrderingDirection={this.state.columnOrdering.columnId() === BUSINESS_UNIT_COLUMN ? this.state.columnOrdering.orderingDirection() : SORT_UP}
                    onSetOrdering={this.handleOrderingChange}
                    thRef={(el) => (this.thRefs[BUSINESS_UNIT_COLUMN] = el)} // Attach ref here
                    onInitResize={this.initResize} // Pass the resize function down
                    additionalButton={this.renderAddBusinessUnitButton(false)}
                />
                {this._renderColumnHeaders()}
            </React.Fragment>
        );
    }

    _renderAlertNoBuAssigned() {
        return <tr data-id="0">
            <td colSpan={this._numberOfColumns()} className="row-loader">
                <div className="dashboard-empty-message">
                    <DashboardSetupOnboarding />
                </div>
            </td>
        </tr>;
    }

    _renderEventualOutOfPeriodBusinessUnits(rowsToRender, rowsEventualOutOfPeriod) {
        const { t } = this.props;
        const toggleText = this.state.showingEventualOutOfPeriodBusinessUnits ? t('dashboard.hide') : t('dashboard.show');

        if(rowsEventualOutOfPeriod.length > 0) {
            rowsToRender.push(<tr data-id="0">
                <td colSpan={this._numberOfColumns()} className="row-loader">
                    <Alert className="alert-warning out-of-period-row">{t('dashboard.there_are_eventual_budgets', {count: rowsEventualOutOfPeriod.length})}<a onClick={() => {this.toggleEventualOutOfPeriodBusinessUnits()}} title={t('dashboard.can_deactivate_budgets')}>[{toggleText}]</a></Alert>
                </td>
            </tr>)

            if(this.state.showingEventualOutOfPeriodBusinessUnits) {
                rowsToRender.push(...rowsEventualOutOfPeriod);
            }
        }
    }

    _renderFilteringMessage(rowsToRender, totalRows, filteredRows) {
        const { t } = this.props;
        if(totalRows === filteredRows)
            return;

        // Sino imprimió ningún presupuesto decimos que es por los filtros
        if(filteredRows === 0) {
            rowsToRender.push(<tr data-id="0">
                <td colSpan={this._numberOfColumns()} className="row-loader">
                    <Alert className="alert-warning filtering-alert">{t('dashboard.no_business_units_found_with_filters')}<a onClick={() => {this.resetFilters()}}>[{t('dashboard.remove_filters')}]</a></Alert>
                </td>
            </tr>)
        } else {
            rowsToRender.push(<tr data-id="0" style={{position:"absolute", zIndex:1}}>
                <td colSpan={this._numberOfColumns()} className="row-loader">
                    <Alert className="alert-warning filtering-alert filtering-data">{t('dashboard.showing_business_units', {filtered: filteredRows, total: totalRows})}<a onClick={() => {this.resetFilters()}}>[{t('dashboard.remove_filters')}]</a></Alert>
                </td>
            </tr>)
        }
    }

    toggleEventualOutOfPeriodBusinessUnits() {
        this.setState({showingEventualOutOfPeriodBusinessUnits: !this.state.showingEventualOutOfPeriodBusinessUnits});
    }

    resetFilters() {
        this._dashboardConfig.resetFilters();

        this.setState({
            filters: {
                textFilter: "",
                issuesOnly: false,
                labelsFilter: [],
                platformFilter: [],
            }
        });
    }

    _numberOfColumns() {
        return (this.state.activeColumns.length+1);
    }

    _renderDashboardRows() {
        if (!this._hasBusinessUnitsToShow()) {
            return this._renderAlertNoBuAssigned()
        }

        // a cada fila se le manda el numero de fila que va a depender de si se esta filtrando o no
        let counter = 1
        const rows = [];
        const rowsEventualOutOfPeriod = [];
        this.state.businessUnits.forEach((businessUnitData) => {
            const data = this._rowDataFor(businessUnitData.id);
            if (data === null || this.matchesFilters(businessUnitData, data)) {
                const hasAdAccountsDataToShow = (data !== null && data.more_than_one_campaigns_configuration);
                const row = <RowWithErrorHandler key={`${businessUnitData.id}-${this.state.refreshKey}`}>
                    <DashboardRow
                        rowOrderNumber={counter}
                        key={`${businessUnitData.id}-${this.state.refreshKey}`}
                        activeColumns={this.state.activeColumns}
                        filterValues={this.state.filters}
                        businessUnitId={businessUnitData.id}
                        businessUnitName={businessUnitData.name}
                        businessUnitType={businessUnitData.type}
                        budgetType={businessUnitData.budget_type}
                        businessUnitData={data}
                        syncInformation={businessUnitData.sync_information}
                        adAccountsData={businessUnitData.campaigns_configuration_rows}
                        hasAdAccountsDataToShow={hasAdAccountsDataToShow}
                        channels={businessUnitData.channels}
                        clientId={businessUnitData.client_id}
                        clientName={businessUnitData.client_name}
                        downUrlsCount={businessUnitData.down_urls_count}
                        hasUrls={businessUnitData.has_urls}
                        generalAlerts={businessUnitData.general_alerts}
                        businessUnitLabels={businessUnitData.labels}
                        onBusinessDataFetched={this.handleBusinessUnitDataFetched}
                        onSnoozeAllAlerts={this.handleSnoozeAllAlerts}
                        onStopSnoozeForAllAlerts={this.handleStopSnoozeForAllAlerts}
                        onLabelsChange={this.handleLabelsChange}
                        agencyFlexIndicators={this.state.flexIndicators}
                        ga4Indicators={this.state.ga4Indicators}
                        ecommerceIndicators={this.state.ecommerceIndicators}
                        paidMediaIndicators={this.state.paidMediaIndicators}
                        metaIndicators={this.state.metaIndicators}
                        location={this.props.location}
                    />
                </RowWithErrorHandler>;

                if(businessUnitData.is_eventual_out_of_period === true) {
                    rowsEventualOutOfPeriod.push(row);
                } else {
                    rows.push(row);
                }
                counter += 1;
            }
        });

        this._renderEventualOutOfPeriodBusinessUnits(rows, rowsEventualOutOfPeriod);
        this._renderFilteringMessage(rows, this.state.businessUnits.length, counter-1);

        return rows;
    }

    _hasBusinessUnitsToShow() {
        return this.state.businessUnits.length > 0;
    }

    isValidColumnId(columnId) {
        const { t } = this.props;
        const columnHeaderInfo = getColumnHeaderInformation(t);
        return columnId in columnHeaderInfo
            || (this.state.flexIndicators != null && this.state.flexIndicators.includes(columnId))
            || (this.state.ga4Indicators != null && this.state.ga4Indicators.includes(columnId))
            || (this.state.ecommerceIndicators != null && this.state.ecommerceIndicators.includes(columnId))
            || (this.state.paidMediaIndicators != null && this.state.paidMediaIndicators.includes(columnId))
            || (this.state.metaIndicators != null && this.state.metaIndicators.includes(columnId));
    }

    _renderColumnHeaders() {
        const { t } = this.props;
        return this.state.activeColumns.map((columnId) => {
            if(!this.isValidColumnId(columnId)) {
                return;
            }

            const columnData = getColumnData(t, columnId);

            return <ColumnHeader
                key={columnId}
                title={columnData['title']}
                subtitle={columnData['subtitle']}
                helper={columnData['helper']}
                columnId={columnId}
                //FEDE: Lo comento porque no lo hice funcionar
                //defaultWidth={this.getColumnDefaultWidth(columnId)}
                isActive={this.state.columnOrdering.columnId() === columnId}
                canBeSorted={this._canBeSorted(columnId)}
                hasHelper={true}
                defaultOrderingDirection={this.state.columnOrdering.columnId() === columnId? this.state.columnOrdering.orderingDirection() : SORT_DOWN}
                onSetOrdering={this.handleOrderingChange}
                thRef={(el) => (this.thRefs[columnId] = el)} // Attach ref here
                onInitResize={this.initResize} // Pass the resize function down
            />
        });
    }

    _canBeSorted(columnId) {
        return columnId !== LABELS_COLUMN;
    }

    /*
    * Lo que sigue estaba en FilterableDashboardRow pero lo subí a este nivel porque necesito mandar el nro de fila
    *  para entender si se debe imprimir gris o blanco.
    *  Esto se hacía desde css con .table-striped tbody tr:nth-of-type(odd) pero en este caso no se puede porque las
    *  filas de los buccs tienen que estar en el mismo color que el bu
    * */
    matchesByTextFilter(businessUnitData) {
        if (this.state.filters.textFilter !== '') {
            const searchString = this.state.filters.textFilter.toLowerCase().trim().match(/(".*?"|\S+)/g) || [];
            const wordsToInclude = searchString.map(text => {
                if (text.startsWith('"') && text.endsWith('"')) {
                    // If keyword is a phrase between double quotes
                    return text.slice(1, -1);
                } else {
                    return text;
                }
            });

            const unionOfAllRowTexts = (businessUnitData.name + businessUnitData.client_name + this._getAdAccountNamesAndIdsText(businessUnitData)).toLowerCase();

            return wordsToInclude.every(keyword => {
                    return unionOfAllRowTexts.includes(keyword.toLowerCase());
            });
        } else {
            return true;
        }
    }

    _getAdAccountNamesAndIdsText(businessUnitData) {
        if (businessUnitData['campaigns_configuration_rows'] === undefined || businessUnitData['campaigns_configuration_rows'] === null)
            return "";

        let textToReturn = "";
        businessUnitData['campaigns_configuration_rows'].forEach((adAccountData) => {
            textToReturn += " " + adAccountData['name'] + " " + adAccountData['account_id'].toString()
        });

        return textToReturn;
    }

    matchesByLabelsFilter(businessUnitData) {
        if (this.state.filters.labelsFilter.length > 0) {
            return this.state.filters.labelsFilter.every((selectedLabel) =>
                businessUnitData.labels.includes(selectedLabel)
            );
        } else {
            return true;
        }
    }

    getIndicatorsColumns() {
        const flexIndicators = this.state.flexIndicators || [];
        const ga4Indicators = this.state.ga4Indicators || [];
        const ecommerceIndicators = this.state.ecommerceIndicators || [];
        const paidMediaIndicators = this.state.paidMediaIndicators || [];
        const metaIndicators = this.state.metaIndicators || [];
        return [...INDICATORS_COLUMNS, ...flexIndicators, ...ga4Indicators, ...ecommerceIndicators, ...paidMediaIndicators, ...metaIndicators];
    }

    matchesByHasIssuesFilter(businessUnitData, data) {
        if (this.state.filters.issuesOnly) {
            const hasDownUrls = businessUnitData.down_urls_count > 0;
            const hasAnIssueAndIsNotSnoozed = this.state.activeColumns.some((column) =>
                this.getIndicatorsColumns().includes(column) && data[column]?.has_issues && !data[column]?.alert_snoozed
            );
            const hasGeneralAlert = businessUnitData.general_alerts.has_no_access_alert || businessUnitData.general_alerts.has_no_impression_alert || businessUnitData.general_alerts.has_campaigns_not_assigned_alert;
            return hasDownUrls || hasAnIssueAndIsNotSnoozed || hasGeneralAlert;
        } else {
            return true;
        }
    }

    matchesByHasPlatformFilter(businessUnitData) {
        const platformFilter = this.state.filters.platformFilter;
        if (!Array.isArray(platformFilter) || platformFilter.length === 0) {
            return true;
        }
        return platformFilter.some((platform) => {
            const platformValue = platform.toUpperCase();
            return businessUnitData.channels.includes(platformValue);
        });
    }

    _computeAvailablePlatforms() {
        const available = new Set();
        this.state.businessUnits.forEach((businessUnitData) => {
            if (Array.isArray(businessUnitData.channels)) {
                businessUnitData.channels.forEach((channel) => available.add(channel));
            }
        });
        return Array.from(available);
    }

    matchesFilters(businessUnitData, data) {
        return this.matchesByTextFilter(businessUnitData) &&
            this.matchesByLabelsFilter(businessUnitData) &&
            this.matchesByHasIssuesFilter(businessUnitData, data) &&
            this.matchesByHasPlatformFilter(businessUnitData);
    }

    /*
    Lo de FilterableDashboardRow llega hasta acá
    * */
}

export const Dashboard = withTranslation()(DashboardClass);
export default Dashboard;
